import * as types from './mutations_types'

export default {
    [types.TOGGLE_MAIN_MENU] (state) {
        state.isMainMenuOpen = !state.isMainMenuOpen
    },
    [types.CLEAR_STATE] (state) {
        state = {
            isMainMenuOpen: true,
            roles: [],
            productUnits: [],
            gender: [],
            languages: [],
            deal: {
                fields: [],
                perceptions: [],
                status: []
            },
            incoming: {
                status: []
            },
            task: {
                status: []
            },
            quotation: {
                status: []
            },
            reports: {
                sales: {
                    types: []
                }
            },
            emails: {
                status: [],
                senders: []
            },
            integrations: {
                approaches: []
            },
            webhook: {
                fields: []
            }
        }
    },
    [types.INIT_STATE] (state) {
        state.isMainMenuOpen = true
        state.roles = [
            { id: 'admin', name: 'admin' },
            { id: 'consultant', name: 'consultant' },
            { id: 'manager', name: 'manager' }
        ]
        state.productUnits = [
            { id: 'grams', name: 'grams' },
            { id: 'hours', name: 'hours' },
            { id: 'kilograms', name: 'kilograms' },
            { id: 'liters', name: 'liters' },
            { id: 'millilitres', name: 'millilitres' },
            { id: 'months', name: 'months' },
            { id: 'others', name: 'others' },
            { id: 'semesters', name: 'semesters' },
            { id: 'times', name: 'times' },
            { id: 'units', name: 'units' },
            { id: 'weeks', name: 'weeks' },
            { id: 'years', name: 'years' }
        ]
        state.gender = [
            { id: 'female', name: 'female' },
            { id: 'male', name: 'male' }
        ]
        state.languages = [
            { id: 'en-US', name: '_languages.en-US' },
            { id: 'pt-BR', name: '_languages.pt-BR' }
        ]
        state.deal = {
            fields: [
                { id: 'first_name', name: 'first_name' },
                { id: 'last_name', name: 'last_name' },
                { id: 'reference', name: 'reference' },
                { id: 'email', name: 'email' },
                { id: 'phone', name: 'phone' },
                { id: 'mobile', name: 'mobile' },
                { id: 'address', name: 'address' },
                { id: 'complement', name: 'complement' },
                { id: 'district', name: 'district' },
                { id: 'zip_code', name: 'zip_code' },
                { id: 'city', name: 'city' },
                { id: 'state', name: 'state' },
                { id: 'gender', name: 'gender' },
                { id: 'facebook', name: 'facebook' },
                { id: 'linkedin', name: 'linkedin' },
                { id: 'gplus', name: 'gplus' },
                { id: 'pinterest', name: 'pinterest' },
                { id: 'twitter', name: 'twitter' },
                { id: 'site', name: 'site' },
                { id: 'instagram', name: 'instagram' },
                { id: 'interests', name: 'interests' },
                { id: 'comments', name: 'comments' }
            ],
            perceptions: [
                { id: 'hot', name: 'hot' },
                { id: 'warm', name: 'warm' },
                { id: 'cold', name: 'cold' },
                { id: 'no_perception', name: 'no_perception' }
            ],
            status: [
                { id: 'open', name: 'open' },
                { id: 'sold', name: 'sold' },
                { id: 'lost', name: 'lost' }
            ]
        }
        state.incoming = {
            status: [
                { id: 'pending', name: 'pending' },
                { id: 'accepted', name: 'accepted' },
                { id: 'refused', name: 'refused' }
            ]
        }
        state.task = {
            status: [
                { id: 'canceled', name: 'canceled' },
                { id: 'pending', name: 'pending' },
                { id: 'done', name: 'done' }
            ]
        }
        state.quotation = {
            status: [
                { id: 'new', name: 'new' },
                { id: 'approved', name: 'approved' },
                { id: 'refused', name: 'refused' },
                { id: 'sent', name: 'sent' }
            ]
        }
        state.reports = {
            sales: {
                types: [
                    { id: 'daily', name: 'daily' }
                ]
            }
        }
        state.emails = {
            status: [
                { id: 'bounce', name: 'bounce' },
                { id: 'click', name: 'click' },
                { id: 'deferred', name: 'deferred' },
                { id: 'delivered', name: 'delivered' },
                { id: 'dropped', name: 'dropped' },
                { id: 'open', name: 'open' },
                { id: 'processed', name: 'processed' },
                { id: 'queued', name: 'queued' },
                { id: 'scheduled', name: 'scheduled' },
                { id: 'spamreport', name: 'spamreport' },
                { id: 'trapped', name: 'trapped' }
            ],
            senders: [
                { id: 'member', name: 'consultant' },
                { id: 'lead', name: 'lead' }
            ]
        }
        state.integrations = {
            approaches: [
                {id: 'sequential_deal', name: 'sequential_deal'},
                {id: 'sequential_incoming', name: 'sequential_incoming'},
                {id: 'low', name: 'low'},
                {id: 'random', name: 'random'},
                {id: 'full', name: 'full'}
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/global/mutations.js